import { Divider } from '@mui/material';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';
import './ContainerWithSideBar.scss';

const defaultProps = {
  sideBar: null,
  content: null,
};
const ContainerWithSideBar = (props) => {
  const { sideBar, content } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <div className='container-with-side-bar'>
      <div className='container-sidebar'>
        {sideBar}
      </div>
      <Divider orientation='vertical' />
      <div className='container-content'>
        {content}
      </div>
    </div>
  );
};

export default ContainerWithSideBar;
